// DS: i3.5
import React from 'react';
import IconWrap from '../IconWrap';
const ArrowLeft = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M15.59 20.427a1 1 0 001.413-1.414l-7.07-7.071 7.07-7.071a1 1 0 10-1.414-1.414l-7.778 7.778a1 1 0 000 1.414l7.778 7.778z",
        clipRule: "evenodd"
    })));
ArrowLeft.displayName = 'ArrowLeft';
export default ArrowLeft;
